module.exports = __webpack_public_path__ + "static/img/2_2_1_4.c1f4561c.jpg";